import { EYE_PATH, eyeTransform } from './eye-path';

const TICKS = Array.from({ length: 12 }, (_, i) => i * 30);

/** The rose-eye reduced to what survives at 32px: ring, ticks, lens, pupil. */
export function Logo({ className = 'w-9 h-9' }: { className?: string }) {
  return (
    <svg viewBox="0 0 240 240" className={className} aria-hidden="true">
      <circle
        cx="120"
        cy="120"
        r="112"
        fill="none"
        stroke="#8B9199"
        strokeWidth="5"
      />
      {TICKS.map((deg) => {
        const rad = (deg * Math.PI) / 180;
        const len = deg % 90 === 0 ? 22 : 13;
        const at = (r: number, fn: (n: number) => number) =>
          Number((120 + r * fn(rad)).toFixed(3));
        return (
          <line
            key={deg}
            x1={at(112, Math.sin)}
            y1={at(-112, Math.cos)}
            x2={at(112 - len, Math.sin)}
            y2={at(-(112 - len), Math.cos)}
            stroke="#4E5661"
            strokeWidth="7"
          />
        );
      })}
      <g transform={eyeTransform(120, 120, 158)}>
        <path d={EYE_PATH} fill="#1B2027" />
      </g>
      <circle cx="120" cy="120" r="20" fill="#B4145A" />
    </svg>
  );
}
